export const RESET_SETTING = 'RESET_SETTING';
export const UPDATE_SETTING = 'UPDATE_SETTING';
